import { forwardRef } from 'react';
import { IconButtonProps, IconButton, Typography } from '@mui/material';
import { CloseRounded, FilterList } from '@mui/icons-material';
import { useAppTFunction } from '@retail/app/i18n';

interface Props extends IconButtonProps {
  showFilters: boolean;
  toggleFilters: () => void;
}

export const ToggleFiltersToolbarButton = forwardRef<HTMLButtonElement, Props>(
  ({ showFilters, toggleFilters, ...buttonProps }, ref) => {
    const t = useAppTFunction();
    return (
      <IconButton
        {...buttonProps}
        ref={ref}
        sx={{
          border: '1.5px solid',
          borderColor: 'divider',
          borderRadius: 2,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
          borderBottom: 0,
          bgcolor: showFilters ? 'background.paper' : undefined,
          ...buttonProps.sx,
        }}
        onClick={toggleFilters}
      >
        {showFilters ? (
          <CloseRounded sx={{ color: 'text.secondary' }} fontSize="small" />
        ) : (
          <FilterList sx={{ color: 'text.secondary' }} fontSize="small" />
        )}
        <Typography variant="body2">{t('myAssortment.filter.filter')}</Typography>
      </IconButton>
    );
  }
);
